
import './swiper.less';
import { useJumpLink } from '@/utils/hooks';

const LibBanner = ({ allBannerList }) => {
  const smallBannerList = allBannerList?.smallBannerList;
  const [handlJumpLink] = useJumpLink();

  return (
    <>
      {smallBannerList.length > 0 ? (
        <div className="flex items-center justify-between px-5 mt-2">
          {smallBannerList.map(item => (
            <img
              key={item.id}
              src={item.url}
              alt={item.remark}
              onClick={() => handlJumpLink(item)}
              className="w-[173px] h-[53px] rounded-lg"
            />
          ))}
        </div>
      ) : null}
    </>
  );
};
export default LibBanner;
